import { Badge, Box, Tooltip, Typography } from '@mui/material';
import { IconInfoCircle, IconPointFilled } from '@tabler/icons-react';
import React from 'react';

interface VirtualCategoryProps {
  category: string;
  showTooltip?: boolean;
}

const VirtualCategory: React.FC<VirtualCategoryProps> = (props) => {
  const isMobile = window.innerWidth < 768;
  return (
    <Box
      display={'flex'}
      justifyContent={'start'}
      alignItems={'start'}
      gap={0.5}
    >
      <Badge
        className="category-bg-color"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          borderRadius: '50px',
          fontSize: 11,
          fontWeight: 'bold',
          padding: '0.2rem 0.6rem',
        }}
      >
        <IconPointFilled size={12} />
        {props?.category?.toUpperCase()}
      </Badge>
      {props.showTooltip && !isMobile && (
        <Tooltip
          children={<IconInfoCircle size={20} />}
          enterTouchDelay={0}
          title={
            <>
              <Typography fontSize={'12px'}>
                There are four types of VIRTUALs:
              </Typography>
              <ul
                style={{
                  fontSize: '12px',
                }}
              >
                <li>
                  <span
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    IP Mirror
                  </span>
                  : Behave like a mirror copy of an IP character (e.g.. Gojo
                  Satoru, John Wick, Yoda)
                </li>
                <li>
                  <span
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    User Mirror
                  </span>
                  : Be a personal copy of yourself
                </li>
                <li>
                  <span
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    Functional
                  </span>
                  : Have core function and able to execute a task (e.g., horror
                  story narrative builder, competitive DOTA coach)
                </li>
                <li>
                  <span
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    Generic
                  </span>
                  : Any generic Virtual that does not fall under the above three
                </li>
              </ul>
            </>
          }
        />
      )}
    </Box>
  );
};

export default VirtualCategory;
